(function (angular) {
    'use strict';

    // elementos: Mapa<Letra, List<Object>>. Mapa cuya clave son las letras del alfabeto y su valor los elementos que comienzan por dicha letra.
    // estado: String. Nombre del estado al que ir.
    // sinvalor: String. Añade un botón a la lista de letras que permite saltar a los elementos que no tienen nombre.
    // en caso de no estar vacío. Se le pasa el nombre de la entidad de acuerdo al fichero de mensajes.

    // Se necesita utilizar la operación LetrasService.getMapaLetras para generar el mapa, ignorando mayúsculas y símbolos.

    angular
        .module('app')
        .component('letras', {
            bindings: {
                elementos: '<',
                estado: '@',
                sinvalor: '<',
                todos: '<'
            },
            templateUrl: 'app/components/letras/letras.html',
            /* @ngInject */
            controller: function (ALFABETOingles, $state, $stateParams) {
                var vm = this;
                vm.alfabeto = ALFABETOingles.toUpperCase();
                vm.letraSeleccionada = $stateParams.letra;

                // FIXME: Este sistema es bastante ineficiente.
                // Igual sería mejor generar una única vez una lista que tenga la letra y si tiene elementos.
                // Así no se haría el bucle por cada letra del abecedario.
                // Tal vez el Mapa ya debería traer todas las letras. Para eso habría que modificar la operación de LetrasService.getMapaLetras.

                // Función que comprueba si la letra contiene elementos
                vm.letraContenidaElementos = function (letter) {
                    if ((letter == 'TODO') && ( vm.elementos.length > 0)){
                        return true;
                    }
                    for (i = 0; i < vm.elementos.length; i++) {
                        if (letter == vm.elementos[i]) {
                            return true;
                        }
                    }
                    return false;
                };

                vm.showByLetter = function (letra) {
                    var params = angular.copy($stateParams);
                    params.page = 1;
                    params.letra = letra;
                    $state.go($state.current, params);
                }

            },
            controllerAs: 'ctrl'

        });

})(angular);
